'use client'

import VerificationsContainer from 'pageContainers/VerificationsContainer'

export default function Verifications() {
  return <VerificationsContainer />
}
